import "./style/index.css";
import cx from 'classnames';
import dayjs from 'dayjs';
import isToday from 'dayjs/plugin/isToday';
import React from 'react';
var duration = require('dayjs/plugin/duration');
dayjs.extend(duration);
dayjs.extend(isToday);
var TimeText = function TimeText(props) {
  var className = props.className,
    style = props.style,
    _props$mode = props.mode,
    mode = _props$mode === void 0 ? 'default' : _props$mode,
    fallBack = props.fallBack,
    timeRule = props.timeRule,
    _props$time = props.time,
    time = _props$time === void 0 ? new Date() : _props$time,
    _props$baseTime = props.baseTime,
    baseTime = _props$baseTime === void 0 ? new Date() : _props$baseTime;
  var calcDateDiff = function calcDateDiff(date1, date2) {
    return dayjs(date1).diff(dayjs(date2), 'seconds');
  };
  var isToday = function isToday() {
    return dayjs(time).isToday();
  };
  var defaultTimeShowRule = [{
    diff: 60,
    format: function format() {
      return '刚刚';
    }
  }, {
    diff: [60, 60 * 60],
    format: function format(diff) {
      return "".concat(Math.floor(diff / 60), "\u5206\u949F\u524D");
    }
  }, {
    diff: [60 * 60, 60 * 60 * 24 - 1],
    format: function format() {
      if (isToday()) {
        return dayjs(time).format('HH:mm');
      }
      return dayjs(time).format('昨天 HH:mm');
    }
  }, {
    diff: [60 * 60 * 24 - 1, 60 * 60 * 24 * 2 - 1],
    format: function format() {
      return dayjs(time).format('YYYY-MM-DD');
    }
  }];
  var isValidDate = function isValidDate(value) {
    return dayjs(value).isValid();
  };
  var isValidTimeRule = function isValidTimeRule(rule) {
    if (!Array.isArray(rule)) {
      return false;
    } else {
      for (var i = 0; i < rule.length; i++) {
        var ruleItem = rule[i];
        var _diff = ruleItem.diff;
        var format = ruleItem.format;
        if (typeof _diff !== 'number' && Array.isArray(_diff) && _diff.length !== 2) {
          return false;
        }
        if (typeof format !== 'function') {
          return false;
        }
      }
    }
    return true;
  };
  var renderTextByRules = function renderTextByRules() {
    if (isValidDate(time) && isValidDate(baseTime)) {
      var _diff2 = calcDateDiff(baseTime, time);
      // 传进来的时间在基准时间之后
      if (_diff2 < 0) {
        return undefined;
      }
      var timeRuleArray = function timeRuleArray() {
        if (!timeRule) {
          return defaultTimeShowRule;
        } else if (typeof timeRule === 'function') {
          return timeRule(defaultTimeShowRule, _diff2);
        }
        return timeRule;
      };
      if (isValidTimeRule(timeRuleArray())) {
        for (var i = 0; i < timeRuleArray().length; i++) {
          var _defaultTimeShowRule$ = defaultTimeShowRule[i],
            ruleDiff = _defaultTimeShowRule$.diff,
            format = _defaultTimeShowRule$.format;
          if (typeof ruleDiff === 'number') {
            if (_diff2 <= ruleDiff) {
              return format(_diff2);
            }
          } else if (Array.isArray(ruleDiff) && ruleDiff.length === 2) {
            if (_diff2 > ruleDiff[0] && _diff2 <= ruleDiff[1]) {
              return format(_diff2);
            }
          }
        }
      } else {
        console.warn('不合法的时间规则');
      }
      return dayjs(time).format('YYYY-MM-DD');
    }
    return undefined;
  };
  var renderText = function renderText() {
    if (isValidDate(time) && isValidDate(baseTime)) {
      if (mode !== 'default') {
        var timeDayjs = dayjs(time);
        switch (mode) {
          case 'showDay':
            return timeDayjs.format('YYYY-MM-DD');
          case 'showMin':
            return timeDayjs.format('YYYY-MM-DD HH:mm');
          case 'showSecond':
            return timeDayjs.format('YYYY-MM-DD HH:mm:ss');
        }
      }
      return renderTextByRules();
    }
    return undefined;
  };
  var renderTimeText = function renderTimeText() {
    var timeText = renderText();
    if (timeText === undefined) {
      if (fallBack) {
        if (typeof fallBack === 'function') {
          return fallBack === null || fallBack === void 0 ? void 0 : fallBack();
        }
        return fallBack;
      }
      return null;
    }
    return timeText;
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: cx('dr-timetext', className),
    style: style
  }, renderTimeText()));
};
export default TimeText;